export default {"src":"/_next/static/media/small-terre-rouge.9d5fb0f3.svg","height":307,"width":203,"blurWidth":0,"blurHeight":0};